import PaySlip from '@/app/payroll-slip'
import { ability } from '@/casl/ability'
import TableSkeleton from '@/components/table-skeleton'
import { getFirstAccessibleRoute } from '@/constants/Auth'
import { payrollSlipsByCompanyIdQueryOptions } from '@/hooks/usePayrollSlipsQuery'
import LocalStorage from '@/utilities/LocalStorage'
import { createFileRoute, redirect } from '@tanstack/react-router'

const RouteComponent = () => {
  return <PaySlip />
}

export const Route = createFileRoute('/_auth/_withProject/payroll-slip')({
  beforeLoad: ({ context }) => {
    if (
      ability &&
      context.auth.user &&
      !ability.can('read', 'Ücret Pusulası')
    ) {
      // toast.error("Bu sayfayı görüntüleme izniniz yok.")
      const permissions = context.auth.user.permissions || []
      const redirectPath = getFirstAccessibleRoute(permissions)
      throw redirect({
        to: redirectPath,
      })
    }
  },
  loader: async ({ context }) => {
    const { queryClient } = context

    const companyId = LocalStorage.selectedCompany()?.id

    await queryClient.prefetchQuery(payrollSlipsByCompanyIdQueryOptions(companyId))
    return {}
  },
  pendingComponent: TableSkeleton,
  component: RouteComponent,
})


